<template>
  <div class="registerAgreement">
    <div class="registerAgreement-top">
      <h3>{{ info.title }}</h3>
      <div
          v-if="info.content"
          v-html="info.content"

      ></div>
      <div v-else class="agreement-msg">未找到信息</div>
    </div>

  </div>
</template>

<script>
import {privacyPolicy} from "@/api/Login";
export default {
  name: "RegisterAgreement",
  data() {
    return {
      info:{},
    };
  },
  mounted() {
    this.load()
  },
  methods: {
    load(){
      privacyPolicy(51).then(res=>{
        this.info=res.data
      })
    }
  },
};
</script>


<style lang="scss">
.registerAgreement {
  .registerAgreement-top {
    width: 1280px;
    margin: 0 auto;
    h3{
      margin-top: 30px;
      margin-bottom: 15px;
      font-size: 20px;
    }

    .agreement-msg{
      margin: 50px auto;
      font-size: 30px;
      color: #333333;
    }
    p {
      line-height: 20px;
      height: 20px;
      text-indent: 2em;
      //font: lighter 15px/29px "PingFangSC-Ultralight", "PingFang SC Ultralight",
      //"PingFang SC", sans-serif;
    }
  }

}
</style>
